import * as React from "react";

const NISInfoIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 2.5C5.85742 2.5 2.5 5.85742 2.5 10C2.5 14.1426 5.85742 17.5 10 17.5C14.1426 17.5 17.5 14.1426 17.5 10C17.5 5.85742 14.1426 2.5 10 2.5ZM10 6.25C10.5177 6.25 10.9375 6.66982 10.9375 7.1875C10.9375 7.70518 10.5177 8.125 10 8.125C9.48232 8.125 9.0625 7.70605 9.0625 7.1875C9.0625 6.66895 9.48145 6.25 10 6.25ZM11.1719 13.75H8.82812C8.44141 13.75 8.125 13.4365 8.125 13.0469C8.125 12.6572 8.43994 12.3438 8.82812 12.3438H9.29688V10.4688H9.0625C8.67432 10.4688 8.35938 10.1538 8.35938 9.76562C8.35938 9.37744 8.67578 9.0625 9.0625 9.0625H10C10.3882 9.0625 10.7031 9.37744 10.7031 9.76562V12.3438H11.1719C11.5601 12.3438 11.875 12.6587 11.875 13.0469C11.875 13.4351 11.5615 13.75 11.1719 13.75Z"
                fill="#333333"
            />
        </svg>
    );
};

export default React.memo(NISInfoIcon);
